<template>

  <m-pay-layout>

    <v-layout v-cloak>
      <v-flex v-if="!hasAdminRole">
        <m-pay-generic-viewer class="my-2 mx-2"
          title="Employee Details"
          :loading="loading"
          :bean="company"
          :beanProperties="viewableProperties"
        >
        </m-pay-generic-viewer>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around :column="$vuetify.breakpoint.smAndDown">
      <v-flex>
        <v-card class="my-2 mx-2">
          <v-card-title>
            <span class="headline">User Details</span>
          </v-card-title>

          <m-pay-user-details-editor
            :user="user"
            :loading="loading"
            @submit="updateUser"
          />

        </v-card>
      </v-flex>

      <v-flex class="restrict-width">

        <m-pay-generic-editor class="my-2 mx-2"
                              :loading="loading"
                              :bean="password"
                              :beanProperties="editableProperties"
                              :validationRules="editableRules"
                              :inputTypes="inputTypes"
                              title="Update password"
                              description="Use a few words, avoid common phrases.
            No need for symbols, digits, or uppercase letters."
                              @submit="updatePassword"
        >
          <template slot="submitButton">
            Update
            <v-icon right dark>edit</v-icon>
          </template>
        </m-pay-generic-editor>

      </v-flex>
    </v-layout>
  </m-pay-layout>
</template>

<script>
import axios from 'axios';
import queries from '../utils/queries';
import roles from '../utils/user-roles';
import MPayGenericEditor from './MPayGenericEditor';
import MPayGenericViewer from './MPayGenericViewer';
import MPayUserDetailsEditor from './MPayUserDetailsEditor';

export default {
  name: 'MPayUserProfileView',

  components: { MPayGenericEditor, MPayUserDetailsEditor, MPayGenericViewer },

  data: () => ({
    user: {},
    company: {},
    password: {
      currentPassword: '',
      newPassword: '',
      repeatNewPassword: '',
    },
    editableProperties: [
      'currentPassword',
      'newPassword',
      'repeatNewPassword',
    ],
    viewableProperties: [
      'companyName',
      'position',
      'role',
    ],
    editableRules: [
      'required',
      'required|isStrong',
      'required|isSame:newPassword',
    ],
    inputTypes: {
      currentPassword: 'password',
      newPassword: 'password',
      repeatNewPassword: 'password',
    },
    loading: false,
  }),
  computed: {
    hasAdminRole() {
      return this.$store.getters.hasAnyRole(roles.READ_ANY_USER);
    },
  },
  methods: {
    fetchUser() {
      this.loading = true;
      axios.get(queries.myUser())
        .then((response) => {
          this.loading = false;
          this.user = response.data;
          if (!this.hasAdminRole) {
            this.fetchEmployeeDetails();
          }
        })
        .catch((e) => {
          this.loading = false;
          this.showError(e);
        });
    },
    fetchEmployeeDetails() {
      axios.get(queries.myCompany())
        .then((response) => {
          this.company = response.data;
        })
        .catch((e) => {
          this.loading = false;
          this.showError(e);
        });
    },
    updateUser(user) {
      this.loading = true;
      /* eslint-disable no-param-reassign */
      user.id = this.user.id;
      axios.put(queries.myUser(), user)
        .then(() => {
          this.loading = false;
          this.showSuccessMessage('User successfully updated.');
          this.fetchUser();
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    updatePassword(model) {
      this.$validator.validateAll('password-form')
        .then((isValid) => {
          if (isValid) {
            this.loading = true;
            this.password = model;
            axios.put(queries.userChangePassword(), {
              userId: this.user.id,
              currentPassword: this.password.currentPassword,
              newPassword: this.password.newPassword,
            })
              .then(() => {
                this.loading = false;
                this.showSuccessMessage('Password updated successfully');
                this.password = {};
                this.$validator.reset();
              })
              .catch((e) => {
                this.showError(e);
                this.loading = false;
              });
          } else {
            this.showValidationErrorMessage();
          }
        });
    },
  },
  created() {
    this.fetchUser();
  },
};
</script>

<style>
  .restrict-width {
    max-width: 50%;
  }
  [v-cloak] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/MPayUserProfileView.vue